import { Button, Popconfirm } from "antd";
import axios from "axios";
import React from "react";
import { Link } from "react-router-dom";
import { QuestionCircleOutlined } from "@ant-design/icons";

function LanguageTable({ data, getLanguageData, initialVlue, handleChange, reset }) {
  const handleLanguageDelete = async (id) => {
    try {
      const delet = await axios.delete(
        `https://abarishr.hennainternational.in/api/language/delete/${id}`
      );
      // console.log(delet);
      getLanguageData(1);
    } catch (error) { }
  };

  https: return (
    <>
      <div className="pageTable">
        <div className="tableLength d-flex form-search">
          <div className="dataTables_length">
            <input
              type="text"
              className="form-control"
              name="search"
              id="language_level"
              autoComplete="off"
              placeholder="search..."
              style={{ width: '600px' }}
              value={initialVlue?.search}
              onChange={handleChange}
            />
          </div>

          <div className="dataTables_length">
            <button type="button" className="btn btn-primary me-2" onClick={() => getLanguageData(1)}>Search</button>
            <button type="button" className="btn btn-primary" onClick={() => reset(1)}>reset</button>
          </div>
        </div>
        <table className="table table-striped table-bordered ">
          <thead>
            {/* <tr role="row" className="filter">
              <td>
                <input
                  type="text"
                  className="form-control"
                  autoComplete="off"
                  placeholder="Language"
                />
              </td>
              <td>
                <input
                  type="text"
                  className="form-control"
                  autoComplete="off"
                  placeholder="Native"
                />
              </td>
              <td>
                <input
                  type="text"
                  className="form-control"
                  autoComplete="off"
                  placeholder="ISO Code"
                />
              </td>
              <td className="cityTab">
                <select defaultValue={"is RTL"} className="form-select">
                  <option value="is RTL">is RTL</option>
                  <option value="RTL">RTL</option>
                  <option value="LTR">LTR</option>
                </select>
              </td>
              <td className="cityTab">
                <select defaultValue={"is Default"} className="form-select">
                  <option value="is Default">is Default</option>
                  <option value="Hongkong">Default</option>
                  <option value="Hongkong">Not Default</option>
                </select>
              </td>
              <td>
                <select name="is_active" id="is_active" className="form-select">
                  <option value={-1}>Is Active?</option>
                  <option value={1} selected="selected">
                    Active
                  </option>
                  <option value={0}>In Active</option>
                </select>
              </td>
            </tr> */}
            <tr role="row" className="heading">
              <th>Language</th>
              <th>Native</th>
              <th>ISO Code</th>
              <th>is RTL</th>
              <th>is Default </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.data?.map((item) => {
                return (
                  <tr role="row" className="odd" key={item._id}>
                    <td className="sorting_1">{item?.lang}</td>

                    <td>{item?.native}</td>
                    <td>{item?.iso_code}</td>
                    <td>{item.is_rtl == 1 ? "Yes" : "No"}</td>
                    <td>{item.is_default == 1 ? "Yes" : "No"}</td>
                    <td>
                      <div className="dropdown">
                        <button
                          className="btn btn-primary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Action
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <Link
                              className="dropdown-item"
                              to={`/admin/edit-language/${item._id}`}
                            >
                              Edit
                            </Link>
                          </li>
                          <li>
                            <Popconfirm
                              title="Delete the task"
                              description="Are you sure to delete this Language?"
                              onConfirm={() => handleLanguageDelete(item?._id)}
                              icon={
                                <QuestionCircleOutlined
                                  style={{
                                    color: "red",
                                  }}
                                />
                              }
                            >
                              <Button danger>Delete</Button>
                            </Popconfirm>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              Mark in Active
                            </a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
}
export default LanguageTable;
